import SidebarComponent from "../components/common/SidebarComponent";
import HOC from "../components/HOC";
import TinodeChatDoctor from "../screen/telemedicine/tinodeChat/TinodeChatDoctor";

const DoctorChatPage = () => {
  const user = {
    fullname: localStorage.getItem("fullname") || "User",
    email: localStorage.getItem("email") || "",
    id: localStorage.getItem("user_id") || "",
    userid_tinode: localStorage.getItem("user_id") || "",
  };

  return (
    <div className="flex">
      <div className="w-0 lg:w-[96px] h-[100vh] sticky top-0 z-30">
        <SidebarComponent />
      </div>

      <div className="w-[100%] lg:w-[calc(100%-96px)]">
        <TinodeChatDoctor user={user} />
      </div>
    </div>
  );
};

export default HOC(DoctorChatPage, "doctor-required");
